/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CredentialIssuanceCompletionRequest
 */
export interface CredentialIssuanceCompletionRequest {
    /**
     * 
     * @type {string}
     * @memberof CredentialIssuanceCompletionRequest
     */
    credentialType?: string;
    /**
     * 
     * @type {string}
     * @memberof CredentialIssuanceCompletionRequest
     */
    recipientUserId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CredentialIssuanceCompletionRequest
     */
    issueeAutomation?: boolean;
}

/**
 * Check if a given object implements the CredentialIssuanceCompletionRequest interface.
 */
export function instanceOfCredentialIssuanceCompletionRequest(value: object): boolean {
    return true;
}

export function CredentialIssuanceCompletionRequestFromJSON(json: any): CredentialIssuanceCompletionRequest {
    return CredentialIssuanceCompletionRequestFromJSONTyped(json, false);
}

export function CredentialIssuanceCompletionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CredentialIssuanceCompletionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'credentialType': json['credentialType'] == null ? undefined : json['credentialType'],
        'recipientUserId': json['recipientUserId'] == null ? undefined : json['recipientUserId'],
        'issueeAutomation': json['issueeAutomation'] == null ? undefined : json['issueeAutomation'],
    };
}

export function CredentialIssuanceCompletionRequestToJSON(value?: CredentialIssuanceCompletionRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'credentialType': value['credentialType'],
        'recipientUserId': value['recipientUserId'],
        'issueeAutomation': value['issueeAutomation'],
    };
}

